import { useConditionDeviationCategoriesOptionsQuery } from 'queries/conditionDeviation';
import { useFilterOptionsQuery } from 'queries/events';

export const useFilterOptions = (categoryFilter?: 'events' | 'conditionDeviations') => {
  const optionsByCds = useConditionDeviationCategoriesOptionsQuery({
    enabled: categoryFilter === 'conditionDeviations',
  });
  const optionsByEvents = useFilterOptionsQuery({
    enabled: categoryFilter !== 'conditionDeviations',
  });
  const data = categoryFilter === 'conditionDeviations' ? optionsByCds.data : optionsByEvents.data;
  const assets = data && 'vessels' in data ? data.vessels : data?.assets;
  const assetsOptions =
    assets?.map((vessel) => ({
      label: vessel.name,
      value: vessel.id,
    })) ?? [];

  const categories = data?.categories ?? [];

  return {
    data: { categories, assetsOptions },
    isLoading: optionsByEvents.isFetching || optionsByCds.isFetching,
  };
};
